import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from '@unipile/ui';
import { ExternalLinkIcon } from 'lucide-react';

export function InstructionsDialog() {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="link" size="sm">
          How to find cookies ?
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>How to find my cookies ?</AlertDialogTitle>
        </AlertDialogHeader>
        <p>Follow the steps to find your linkedin cookies (not available on mobile)</p>
        <ul>
          <li>
            1. Open linkedin in a new tab (or click here:{' '}
            <a className="text-blue-500 underline" href="https://www.linkedin.com" target="_blank" rel="noreferrer">
              linkedin
              <ExternalLinkIcon className="ml-2 inline-block h-4 w-4" />
            </a>
            ).
          </li>
          <li>2. Log in to your account.</li>
          <li>
            3. Open your browser&apos;s developer console (F12 for Chrome and Firefox, option + command + I for Safari) then go to
            the &quot;application&quot; or &quot;storage&quot; tab.
          </li>
          <li>4.Open the cookies folder and click on the one called &quot;https://www.linkedin.com&quot;.</li>
          <li>5. Copy the values for &quot;li_at&quot; into the field below, then click on the connect button</li>
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel>Close</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
